$(function () {
  if (!customElements.get('products-service')) {
    customElements.define(
      'products-service',
      class productsService extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }
        init() {
          const $items = $(this).find('.service-item');

          this.$dialog = $(this).find('dialog-simple');
          // 检查每个item的desc属性
          $items.each(function () {
            const $item = $(this);
            if (!$item.attr('data-desc')) {
              $item.css('pointer-events', 'none');
            }
          });
          $items.on('click', (e) => {
            const $item = $(e.currentTarget);
            this.$dialog.attr({
              'data-show': 'true',
              'data-title': $item.attr('data-title'),
              'data-desc': $item.attr('data-desc'),
              'data-button-text': $item.attr('data-button-text'),
              'data-button-link': $item.attr('data-button-link'),
            });
          });
        }
      }
    );
  }
});
